import styled from 'styled-components';
import { layout, styledUtils, colorUtils } from 'src/components/base';

import { Clickable } from 'src/components/clickable';

export const Media = styled.div`
  position: relative;
  padding: ${layout.measurements.spacing100};

  &::after {
    ${styledUtils.overlay()}
    border-radius: 50%;
    transition: background-color 150ms ease;
  }
`;

export const Button = styled(Clickable)`
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  text-align: center;
  flex: 1 1 auto;
  width: 100%;
  height: 100%;

  > *:not(:last-child) {
    margin-bottom: ${layout.measurements.spacing050};
  }

  &:hover {
    ${Media} {
      &::after {
        background-color: ${p =>
          colorUtils.setRgbaAlpha(p.theme.colors.base800, 0.08)};
      }
    }
  }
`;
